import { Controller } from "@hotwired/stimulus"

// Manages a native <dialog> element that hosts a Turbo Frame.
//
// Wiring:
//   <div data-controller="dialog">
//     <dialog data-dialog-target="dialog" class="...">
//       <turbo-frame id="..." data-action="turbo:frame-load->dialog#open"></turbo-frame>
//     </dialog>
//   </div>
//
// When the frame loads new content (cell click → frame navigates), the
// dialog opens. When the dialog closes, the frame content is cleared so the
// next open doesn't flash the prior brand's data.
export default class extends Controller {
  static targets = ["dialog", "frame"]

  connect() {
    this.dialogTarget.addEventListener("close", this.#onClose)
  }

  disconnect() {
    this.dialogTarget.removeEventListener("close", this.#onClose)
  }

  open() {
    const frame = this.dialogTarget.querySelector("turbo-frame")
    // Avoid opening when the frame loaded its own initial empty-state content
    if (!frame || !frame.innerHTML.trim()) return
    if (!this.dialogTarget.open) this.dialogTarget.showModal()
  }

  close() {
    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  // Click on the backdrop (outside the dialog's child elements) closes it.
  // <dialog> renders its backdrop as ::backdrop on the element itself, so a
  // click event with target === dialog is a backdrop click.
  backdropClick(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  #onClose = () => {
    const frame = this.dialogTarget.querySelector("turbo-frame")
    if (frame) frame.innerHTML = ""
  }
}
